import styled from "styled-components";

export const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  width: 80%;
  gap: 1rem;
  margin: auto;
  margin-top: 3rem;
  margin-bottom: 1rem;
  @media (width<=768px) {
    grid-template-columns: auto;
  }
`;

export const NewsCard = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  align-items: flex-start;
  height: 18rem;
  margin-bottom: 1rem;
  img {
    height: 40%;
    width: 100%;
    object-fit: contain;
  }
  section {
    color: #101e8e;
    display: flex;
    align-items: center;
    flex-direction: column;
    .title {
      width: 100%;
      align-self: flex-start;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 2rem;
  margin-top: 2rem;
  width: 100%;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
  width: 80%;
`;
